export default "__VITE_ASSET__5a3fbda9__"